import FormSelect from 'components/Select/FormSelect';
import { IItemForGetShortInfo, IGetGameCategoriesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getGameCategoriesShortInfoByRestaurantIDs } from 'backend/games';
import React, { useState, useEffect } from 'react';

interface IGameCategorySelect {
	selectedRestaurants: string[];
	setTransitionGameCategory: (value: Nullable<string>) => void;
	setFetchedGameCategories: (value: IItemForGetShortInfo[]) => void;
}

const GameCategorySelect: React.FC<IGameCategorySelect> = ({
	selectedRestaurants,
	setTransitionGameCategory,
	setFetchedGameCategories,
}) => {
	const [isFirstRender, setIsFirstRender] = useState(true);
	const { response, loading, refetch, responseError } = useFetchData<IGetGameCategoriesShort, string[]>(
		getGameCategoriesShortInfoByRestaurantIDs,
		selectedRestaurants,
	);

	useEffect(() => {
		if (!isFirstRender) {
			refetch();
		} else {
			setIsFirstRender(false);
		}
	}, [selectedRestaurants]);

	useEffect(() => {
		response && setFetchedGameCategories(response.data.gameCategories);
	}, [response]);

	return (
		<FormSelect
			testId="GameCategorySelect"
			name="selectedTransitionGameCategory"
			label="gameCategoryLabel"
			options={response?.data.gameCategories}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setTransitionGameCategory}
		/>
	);
};

export default React.memo(GameCategorySelect);
